import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    display: 'flex',
  },
  availableNow: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgb(0, 165, 0)',
  },
  availableSoon: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgb(225, 175, 0)',
  },
  notAvailable: {
    verticalAlign: 'middle',
    animation: 'name-type-appear 0.5s ease-out 0.55s',
    animationFillMode: 'backwards',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  availabilityIcon: {
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
  },
  statusIcon: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(-1),
    verticalAlign: 'middle',
  },
  editButton: {
    marginTop: `${theme.spacing(-2)} !important`,
    marginBottom: `${theme.spacing(-2)} !important`,
  },
  error: {
    display: 'inline',
    color: 'rgb(244, 67, 54)',
    marginTop: theme.spacing(2),
  },
  timezone: {
    marginTop: theme.spacing(-1),
    color: 'rgba(0, 0, 0, 0.65)',
    animation: 'timezone-appear 0.5s ease 0.95s backwards',
  },
}))
